<template>
  <footer class="footer u-flex-col u-row-between">
    <section class="footer-top">
      <section class="footer-left">
        <ul class="ul">
          <li class="li title">{{ i18n.link }}</li>
          <li class="li" v-for="item in linkList" :key="item.id">
            <a :href="item.url" class="link" target="_blank">{{ item.title }}</a>
          </li>
          <!-- <li class="li">
            <a class="link" @click="handleMap" style="cursor:pointer">人才地图</a>
          </li>-->
        </ul>
        <ul class="ul">
          <li class="li title">{{ i18n.time }}</li>
          <li v-text="contactUsDetail.workTime" class="html-wrap li"></li>
        </ul>
        <ul class="ul">
          <li class="li title">{{ i18n.contact }}</li>
          <li class="li">
            <span>市话：</span>
            {{ contactUsDetail.contact }}
          </li>
          <li class="li">
            <span>地址：</span>
            {{ contactUsDetail.address }}
          </li>
        </ul>
      </section>
      <!-- <section class="footer-right"> -->
      <!-- <h2 class="right-title">{{ i18n.title }}</h2> -->
      <!-- <div class="u-flex u-m-t-20">
          <div class="footer-img-box u-m-r-50">
            <img
              src="https://dss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=4247246815,1422026774&fm=26&gp=0.jpg"
              alt
              class="footer-img"
            />
            <span class="color-fff u-font-16">微信公众号</span>
          </div>
          <div class="footer-img-box">
            <img
              src="https://dss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=4247246815,1422026774&fm=26&gp=0.jpg"
              alt
              class="footer-img"
            />
            <span class="color-fff u-font-16">微信公众号</span>
          </div>
      </div>-->
      <!-- </section> -->
    </section>
    <section class="footer-bottom">
      <!-- <div class="u-font-12 color-fff">{{ i18n.unit }}</div> -->
      <div class="bottom-text">
        <span>Copyright&#169;2018 tw2sm.com All Right Reserved</span>
        <span style="margin-left:10px">{{ i18n.bottomText }}</span>
        <a href="https://beian.miit.gov.cn" class="color-fff internetContentProvider" target="_blank">{{ i18n.internetContentProvider }}</a>
      </div>
    </section>
  </footer>
</template>

<script>
import { linkListUrl, contactUsDetailUrl } from '@/api'

export default {
  name: 'foot',
  mounted() {
    this.loadLinkList()
    this.getcontactUsDetail()
  },
  data() {
    return {
      linkList: [],
      contactUsDetail: {} // 联系我们详情
    }
  },
  computed: {
    i18n() {
      return this.$t('layoutFooter')
    }
  },
  methods: {
    // 获取友情链接列表
    async loadLinkList() {
      let { data } = await this.$post(linkListUrl)
      this.linkList = data
    },
    handleMap() {
      this.$router.push({ path: '/map' })
    },
    // 获取联系我们的详情
    async getcontactUsDetail() {
      const { data } = await this.$get(contactUsDetailUrl)
      this.contactUsDetail = data
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  // position: absolute;
  // bottom: 0;
  // left: 0;
  z-index: 2000;
  width: 100%;
  min-width: 1200px;
  height: 270px;
  // padding: 0 calc((100% - 1200px) / 2);
  background-color: $footer-bg-color;
  padding-top: 30px;
}
.footer-top {
  height: 194px;
  display: flex;
  margin: 0 calc((100% - 1200px) / 2);
  justify-content: space-between;
}
.footer-bottom {
  display: flex;
  flex-direction: column;
  align-items: center;
  // justify-content: end;
  // border-top: 1px solid #19288d;
  // border-top: 1px solid rgba(255, 255, 255, 0.2);
  background-color: #27272b;
  // padding: 7px 0;
  padding: 10px 0;
}
.footer-left {
  width: 100%;
  display: flex;
  justify-content: space-between;
  .ul {
    width: 220px;
    // margin-right: 60px;
  }
  .li {
    margin-bottom: 12px;
    color: #fff;
  }
  .link {
    color: #fff;
    &:hover {
      text-decoration: underline;
    }
  }
  .title {
    font-weight: bold;
    color: #fff;
    line-height: 1;
    font-size: 16px;
    margin-bottom: 30px;
  }
}
.footer-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.right-title {
  font-weight: normal;
  font-size: 24px;
  line-height: 1;
  color: #fff;
}
.footer-img-box {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.footer-img {
  width: 90px;
  height: 90px;
  display: block;
  margin-bottom: 8px;
}
.bottom-text {
  padding-left: 24px;
  color: #fff;
  font-size: 12px;
  background: url('../assets/img/beian.png') left center/18px 18px no-repeat;
  .internetContentProvider:hover {
    color: $primary-color;
  }
}
</style>
